module.exports={render:function (){var _vm=this;
  return _vm._h('div', [_vm._h('router-view')])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.1@vue-loader/lib/template-compiler.js?id=data-v-1341f1d4!./~/.10.0.1@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 179
// module chunks = 1